import React from 'react';
import {groupBy, concat, isEmpty} from 'lodash';
import clsx from 'clsx';
import ThumbnailSection from "./ThumbnailSection";

export default function ThumbnailGallery({
  selectedImage, images, callbacks, productGroup = {}, ...props
}) {

  let grouped = groupBy(images, i => i.flavour);

  let mainImages = concat(grouped['group'] || [], grouped['video']);
  let swatches = grouped['group_swatch'];
  let custPhotos = grouped['customer'];

  let className = clsx("thumbs whitespace-nowrap",
    //"overflow-y-hidden overflow-x-scroll",
    //"md:overflow-y-scroll md:overflow-x-hidden",
    "pt-2 md:pt-0 md:pl-2 md:divide-y-2");

  let commonProps = {selectedImage, productGroup, callbacks};

  return <div className={className}>
    {!isEmpty(mainImages) &&
      <ThumbnailSection
        images={mainImages}
        {...commonProps} />
    }

    {!isEmpty(swatches) &&
      <ThumbnailSection className="thumbs-swatch"
        columns={4}
        images={swatches}
        {...commonProps} />
    }

    {!isEmpty(custPhotos) &&
      <div className="hidden md:block text-center">Customer Photos</div>}

      {!isEmpty(custPhotos) &&
      <ThumbnailSection className="thumbs-customer"
        images={custPhotos}
        {...commonProps} />
    }

  </div>
}
